import { Button } from '@avanta/shared/components/ui/Button';
import { FLOW_MODES } from '@avanta/shared/constants/appointments';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { t } from '@avanta/shared/i18n';
import { Pencil } from 'lucide-react';
import { useNavigate } from 'react-router';
import { ROUTES } from 'constants/routes';
import { EditAppointmentDialog } from './EditAppointmentDialog';
import { type EditAppointmentProps, type LocationState } from './types';

export const EditAppointment = ({
  appointment,
  from,
  icon,
  buttonLabel = t('EditSessionDialog.cta', { ns: LOCIZE_NS.INSURANCE }),
}: EditAppointmentProps): React.ReactElement => {
  const { showDialog } = useDialogContext();
  const navigate = useNavigate();

  const handleEditClick = (): void => {
    const handleEditAppointment = (editState: LocationState): void => {
      navigate(ROUTES.APPOINTMENTS_RESERVE, {
        state: { ...editState, from, flow: FLOW_MODES.edit },
      });
    };

    showDialog({
      component: (
        <EditAppointmentDialog appointment={appointment} onSuccess={handleEditAppointment} />
      ),
      state: { patientId: appointment.patientId },
    });
  };

  return (
    <Button variant="secondary" size="lg" onClick={handleEditClick} icon={icon ?? 'leading'}>
      <Pencil className="size-6" />
      {icon !== 'only' && buttonLabel}
    </Button>
  );
};
